import Vue from 'vue'
import stateConfig from './config'
import config from '@/config'
import api from '@/api'
import VueLocalStorage from 'vue-localstorage'
import { cloneDeep, pickBy } from 'lodash'
import { notificationNewChatMessage } from '@/utils/notification'
import axios from 'axios'

import { set as setLocalstorage } from '../utils/VueLocalsotrageWithExpiry'

Vue.use(VueLocalStorage)

export default {
  setLang: function({ commit }, payload) {
    commit(stateConfig.SET_LANG, payload)
  },
  loading: function({ commit }) {
    commit(stateConfig.LOADING)
  },
  login: function({ commit, state }, creds) {
    commit(stateConfig.LOGIN) // show spinner
    return new Promise((resolve, reject) => {
      api.authDefault(creds, function(error, response) {
        if (error) {
          commit(stateConfig.LOGIN_FAIL)
          reject(error)
          return
        }
        if (response.responsecode === 400) {
          resolve({
            code: response.responsecode,
            reason: response.reason
          })
        } else if (response.responsecode === 200) {
          state.botlist = response.botlist
          state.userid = creds.userid
          state.isFacebook = false
          state.loginChannel = 'account'
          state.accessToken = response.sessiontoken

          if (state.botlist.length == 0) {
            state.newcomer = true
            Vue.localStorage.set('newcomer', state.newcomer)
          } else {
            state.newcomer = false
            Vue.localStorage.set('newcomer', state.newcomer)
          }

          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('userid', state.userid)
          Vue.localStorage.set('token', state.accessToken)
          Vue.localStorage.set('FB', state.isFacebook)
          Vue.localStorage.set('loginChannel', state.loginChannel)

          if (response.type) {
            state.loginType = response.type
            Vue.localStorage.set('loginType', state.loginType)
          }

          if (response.privilege) {
            state.privilege = JSON.parse(response.privilege)
            Vue.localStorage.set('privilege', response.privilege)
          }
          if (response.partner_code) {
            state.partner_code = response.partner_code
            Vue.localStorage.set('partner_code', state.partner_code)
          } else {
            state.partner_code = undefined
            Vue.localStorage.set('partner_code', state.partner_code)
          }

          commit(stateConfig.LOGIN_SUCCESS)
          resolve({
            code: response.responsecode
          })
        }
      })
    })
  },
  async loginLine({ commit, state, dispatch }, payload) {
    commit(stateConfig.LOGIN) // show spinner

    var pagelist = []
    try {
      pagelist = payload.pageidlist.map(el => {
        return {
          access_token: null,
          category: '',
          category_list: [],
          id: el,
          name: '',
          pagelogo: '',
          name_with_location_descriptor: '',
          channel: 'line',
          tasks: ['ANALYZE', 'ADVERTISE', 'MESSAGING', 'MODERATE', 'CREATE_CONTENT', 'MANAGE']
        }
      }, [])
    } catch (error) {}
    state.userid = payload.userid
    state.pagelist = pagelist
    state.isFacebook = true
    state.loginChannel = 'line'
    state.accessToken = payload.sessiontoken

    Vue.localStorage.set('userid', state.userid)
    Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
    Vue.localStorage.set('FB', state.isFacebook)
    Vue.localStorage.set('token', state.accessToken)
    Vue.localStorage.set('loginChannel', state.loginChannel)
    let data = {
      userid: state.userid,
      pageidlist: pagelist.map(el => el.id, []),
      access_type: 'LINE_MODULAR'
    }

    try {
      // if (pagelist.length > 0) {
      let response = await dispatch('getBotlist', data)
      await dispatch('updateAccountDetail', response)
      if (response.botlist.length > 0) {
        state.pagelist[0].name = response.botlist[0].pagename
        Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
      }

      if (state.facebook_info) {
        let pagelist_response = await dispatch('getPageList', {
          token: state.facebook_info.facebook_access_token,
          limit: 1000
        })
        let pagelist = []
        if (pagelist_response) {
          pagelist = pagelist_response.map(function(page) {
            return page.id
          })
        }
        state.pagelist = pagelist_response
        state.fbAccessToken = state.facebook_info.facebook_access_token
        state.isFacebook = true

        Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
        Vue.localStorage.set('fbtoken', state.fbAccessToken)
        Vue.localStorage.set('FB', state.isFacebook)
      }
      // }
      commit(stateConfig.LOGIN_SUCCESS)
    } catch (error) {
      commit(stateConfig.LOGIN_FAIL)
      throw error
    }
  },
  getLongLiveToken({}, creds) {
    return new Promise((resolve, reject) => {
      api.getLongLiveToken(creds, (error, response) => {
        if (error) reject(error)
        resolve(response)
      })
    })
  },
  async getPageList({ dispatch }, data) {
    try {
      let response = await dispatch('getPageListApi', data)
      return response.pages || []
    } catch (error) {
      try {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message ==
            "Please reduce the amount of data you're asking for, then retry your request"
        ) {
          let { pages } = await dispatch('recursivePageList', { ...data, limit: 20 })
          return pages
        }
      } catch (error) {
        return false
      }
      return false
    }
  },
  async recursivePageList({ dispatch }, data) {
    let result = {
      pages: []
    }
    try {
      var response = await dispatch('getPageListApi', data)
      if (response && response.pages && response.pages.length > 0) {
        if (response.is_next) {
          var pages = await dispatch('recursivePageList', { url: response.is_next })
          return {
            pages: [...pages.pages, ...response.pages]
          }
        } else {
          return {
            pages: response.pages
          }
        }
      } else {
        throw new Error('Not have response')
      }
    } catch (error) {
      console.log(error)
      return result
    }
  },
  async getPageListApi({}, data) {
    try {
      let response = await api.getPageList(data)
      return response
    } catch (error) {
      throw error
    }
  },
  async updateManualPagelist({ state, dispatch }, payload) {
    let pagelist = []
    if (state.pagelist) {
      pagelist = state.pagelist
    }
    pagelist = [...pagelist, ...payload.pagelist]
    try {
      let data = {
        userid: state.userid,
        pageidlist: pagelist.map(el => el.id, []),
        access_type: 'LINE_MODULAR'
      }
      if (pagelist.length > 0) {
        let response = await dispatch('getBotlist', data)
        await dispatch('updateAccountDetail', response)
        if (response.botlist.length > 0) {
          try {
            pagelist = pagelist.map(el => {
              let page = response.botlist.find(p => el.id == p.id)
              if (page) {
                el.name = page.pagename
              }
              return el
            })
          } catch (error) {
            console.error(error)
          }
          state.pagelist = pagelist
          Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
        }
      }
    } catch (error) {
      throw error
    }
  },
  async loginFB({ commit, state, dispatch }, creds) {
    commit(stateConfig.LOGIN)
    let response
    try {
      response = await dispatch('getLongLiveToken', creds)
    } catch (error) {
      commit(stateConfig.LOGIN_FAIL)
      throw error
    }

    try {
      let pagelist_response = await dispatch('getPageList', {
        token: response.longlivetoken,
        limit: 1000
      })
      let pagelist = []
      if (pagelist_response) {
        pagelist = pagelist_response.map(function(page, index) {
          return page.id
        })
      }

      state.userid = creds.userid
      state.pagelist = pagelist_response
      state.fbAccessToken = response.longlivetoken
      state.isFacebook = true
      state.loginChannel = creds.channel
      state.fbScope = creds.scope

      Vue.localStorage.set('fbtoken', state.fbAccessToken)
      Vue.localStorage.set('userid', state.userid)
      Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
      Vue.localStorage.set('FB', state.isFacebook)
      Vue.localStorage.set('loginChannel', state.loginChannel)
      Vue.localStorage.set('fbScope', state.fbScope)
      let data = {
        userid: creds.userid,
        pageidlist: pagelist,
        access_token: state.fbAccessToken
      }

      let botlist_response = await dispatch('getBotlist', data)
      await dispatch('updateAccountDetail', botlist_response)
      commit(stateConfig.LOGIN_SUCCESS)
    } catch (error) {
      commit(stateConfig.LOGIN_FAIL)
      throw error
    }
  },
  async connectFB({ commit, state, dispatch }, creds) {
    let response = null,
      responsePageList = null
    try {
      response = await dispatch('getLongLiveToken', creds)
    } catch (error) {
      commit(stateConfig.LOGIN_FAIL)
      return error
    }
    try {
      responsePageList = await dispatch('getPageList', {
        token: response.longlivetoken,
        limit: 1000
      })
      let pageidlist = []
      if (responsePageList) {
        pageidlist = responsePageList.map(page => page.id)
      }

      // state.userid = creds.userid
      state.pagelist = responsePageList
      state.fbAccessToken = response.longlivetoken
      state.fbScope = creds.scope

      Vue.localStorage.set('fbtoken', state.fbAccessToken)
      // Vue.localStorage.set('userid', state.userid)
      Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
      Vue.localStorage.set('fbScope', state.fbScope)
      return true
    } catch (error) {
      commit(stateConfig.LOGIN_FAIL)
      return error
    }
  },
  updateNewBotlist: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      let pagelist = []
      if (state.pagelist) {
        pagelist = state.pagelist.map(function(value) {
          return value.id
        })
      }

      let data = {
        userid: state.userid,
        pageidlist: pagelist,
        access_token: state.fbAccessToken
      }
      dispatch('getBotlist', data).then(
        response => {
          dispatch('updateAccountDetail', response).then(() => {
            // commit(stateConfig.LOGIN_SUCCESS)
            if (state.selectedBot != null) {
              if (state.botlist) {
                let bot = state.botlist.find(val => val.pageid === state.selectedBot.pageid)
                if (bot) dispatch('selectBot', bot)
              }
            }
            resolve()
          })
        },
        error => {
          // commit(stateConfig.LOGIN_FAIL)
          reject(error)
        }
      )
    })
  },
  getBotlist: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      api.checkBotlist(data, function(error, response) {
        if (error) {
          reject(new Error(error))
        }

        if (response && response.pageidlist) {
          let botlist = response.botlist
          commit('SET_BOTLIST', botlist)
          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          if (response.facebook_info) commit('UPDATE_FB_INFO', response.facebook_info)
          if (response.line_info) commit('UPDATE_LINE_INFO', response.line_info)

          state.accessToken = response.sessiontoken
          Vue.localStorage.set('token', state.accessToken)

          resolve(response)
        }
      })
    })
  },
  updateAccountDetail({ state }, data) {
    return new Promise(resolve => {
      if (state.isFacebook) {
        state.facebook_name = data.facebook_name ? data.facebook_name : ''
      } else {
        state.facebook_name = state.userid
      }
      Vue.localStorage.set('facebook_name', state.facebook_name)

      if (data.partner_code) {
        state.partner_code = data.partner_code
        Vue.localStorage.set('partner_code', state.partner_code)
      } else {
        state.partner_code = undefined
        Vue.localStorage.set('partner_code', state.partner_code)
      }
      resolve()
    })
  },
  logout: function({ commit, state }, error) {
    return new Promise((resolve, reject) => {
      Vue.localStorage.remove('hideads')
      Vue.localStorage.remove('dialogSalepage')
      Vue.localStorage.remove('token')
      Vue.localStorage.remove('userid')
      Vue.localStorage.remove('botlist')
      Vue.localStorage.remove('selectedBot')
      Vue.localStorage.remove('fbtoken')
      // Vue.localStorage.remove('FB')
      Vue.localStorage.remove('pagelist')
      Vue.localStorage.remove('partner_code')
      Vue.localStorage.remove('facebook_info')
      Vue.localStorage.remove('line_info')
      Vue.localStorage.remove('privilege')
      Vue.localStorage.remove('loginType')

      state.loginType = null
      state.privilege = { role: null }
      state.userid = null
      state.botlist = null
      state.selectedBot = null
      state.isSelectedBot = false
      // state.isFacebook = false
      state.accessToken = null
      state.fbAccessToken = null
      state.pagelist = null
      state.partner_code = undefined
      if (error) {
        state.systemError = error
      }
      // eslint-disable-next-line no-undef
      if ($('.modal-backdrop')) {
        // eslint-disable-next-line no-undef
        $('.modal-backdrop').remove()
      }
      commit(stateConfig.LOGOUT)

      resolve()
    })
  },
  selectBot: function({ state, commit, dispatch }, bot) {
    return new Promise(resolve => {
      if (state.selectedBot && bot && bot.pageid !== state.selectedBot.pageid) {
        dispatch('updatePaypalTrackingId', null)
      }
      Vue.localStorage.set('selectedBot', JSON.stringify(bot))
      commit(stateConfig.SELECT_NEW_BOT, bot)
      commit(stateConfig.SELECT_BOT)
      resolve()
    })
  },
  unselectBot: function({ state, commit, dispatch }) {
    dispatch('updatePaypalTrackingId', null)
    Vue.localStorage.remove('selectedBot')
    state.selectedBot = null
    state.isSelectedBot = false
  },
  updateBotlist: function({ state }, botlist) {
    state.botlist = botlist
    Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
  },
  async updatePagelist({ state, dispatch }) {
    if (!state.isFacebook) {
      return false
    }
    try {
      let response = await dispatch('getPageList', {
        token: state.fbAccessToken,
        limit: 1000
      })
      state.pagelist = response
      Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))

      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },
  sidebar: function({ commit, state }, value) {
    if (value) {
      // console.log(value)
      commit(stateConfig.SIDEBAR)
    }
    commit(stateConfig.SIDEBAR)
  },
  updatePaypalTrackingId: function({ commit, state }, value) {
    state.paypalTrackingId = value
    if (value == null) {
      Vue.localStorage.remove('paypalTrackingId')
    } else {
      Vue.localStorage.set('paypalTrackingId', state.paypalTrackingId)
    }
  },
  updateMerchantId: function({ commit, state }, value) {
    state.selectedBot.paypal_merchantid = value
    Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
    commit(stateConfig.SELECT_NEW_BOT, state.selectedBot)
    commit(stateConfig.SELECT_BOT)
  },
  updateSetting: function({ commit, state }, value) {
    commit(stateConfig.UPDATE_SETTING, value)
  },
  updateWelcomeMessage2: function({ commit, state }, value) {
    commit(stateConfig.UPDATE_WELCOME_MESSAGE2, value)
  },
  updateWelcomeMessage: function({ commit, state }, value) {
    commit(stateConfig.UPDATE_WELCOME_MESSAGE, value)
  },
  updateBotDetail: function({ commit, state }) {
    return new Promise((resolve, reject) => {
      let data = { pageid: state.selectedBot.pageid }
      api.getBotDetail(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          // if (response.data.hasOwnProperty('page_access_token')) {
          //   delete response.data.page_access_token
          // }
          state.selectedBot = { ...state.selectedBot, ...response.data }

          Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
          if (state.botlist) {
            var bot_index = state.botlist.findIndex(function(bot) {
              return bot.pageid === state.selectedBot.pageid
            })
            if (bot_index != -1) {
              Vue.set(state.botlist, bot_index, state.selectedBot)
              Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
            }
          }
          commit(stateConfig.SELECT_BOT)
        }

        resolve(response)
      })
    })
  },
  addModalWelcome: function({ commit, state }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, true)
  },
  clearModalWelcome: function({ commit, state }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, false)
  },
  clearAlert: function({ state, commit }, name) {
    var pageid = null
    if (state.selectedBot) {
      pageid = state.selectedBot.pageid
    }
    commit(stateConfig.UPDATE_ALERT, { name: name, show: false, pageid: pageid })
  },
  getProducts: function({ state }, offset) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }
      if (
        state.selectedBot.useketshop == true &&
        state.selectedBot.ketshop_api_key &&
        state.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = state.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = state.selectedBot.ketshop_api_secret
        data['limit'] = 10
      } else {
        data['limit'] = 300
      }

      data['offset'] = offset

      api.getProducts(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.productlist) {
          resolve(response)
        } else {
          reject()
        }
      })
    })
  },
  loadProducts: function({ state, dispatch }) {
    if (state.ecommerce.products && state.ecommerce.products.length !== 0) {
      state.ecommerce.loadingProduct = false
    } else {
      return new Promise((resolve, reject) => {
        state.ecommerce.loadingProduct = true
        let offset = 0
        let allProduct = []
        dispatch('getProducts', offset).then(
          async products => {
            if (
              state.selectedBot.useketshop == true &&
              state.selectedBot.ketshop_api_key &&
              state.selectedBot.ketshop_api_secret
            ) {
              offset = offset + 10
            } else {
              offset = offset + 300
            }
            allProduct = products.productlist
            state.ecommerce.products = allProduct
            state.ecommerce.totalProduct = products.total_records
            state.ecommerce.loadingProduct = false
            for (
              offset;
              offset < products.total_records;
              offset +=
                state.selectedBot.useketshop == true &&
                state.selectedBot.ketshop_api_key &&
                state.selectedBot.ketshop_api_secret
                  ? 10
                  : 300
            ) {
              var prod = await dispatch('getProducts', offset)
              allProduct = allProduct.concat(prod.productlist)
              state.ecommerce.products = allProduct
            }
            resolve()
          },
          error => {
            console.error(error)
            state.ecommerce.loadingProduct = false
            reject(error)
          }
        )
      })
    }
  },
  getCategories: function({ state }) {
    return new Promise((resolve, reject) => {
      var data = {
        pageid: state.selectedBot.pageid
      }
      if (
        state.selectedBot.useketshop == true &&
        state.selectedBot.ketshop_api_key &&
        state.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = state.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = state.selectedBot.ketshop_api_secret
      }
      api.getCategories(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.categorylist) {
          resolve(response.categorylist)
        } else {
          reject()
        }
      })
    })
  },
  loadCategory: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingCategory = true
      if (state.ecommerce.categories.length === 0) {
        dispatch('getCategories').then(
          categories => {
            state.ecommerce.categories = categories
            state.ecommerce.loadingCategory = false
            resolve()
          },
          error => {
            console.error(error)
            state.ecommerce.loadingCategory = false
            reject(error)
          }
        )
      } else {
        state.ecommerce.loadingCategory = false
      }
    })
  },

  renameKey(object, key, newKey) {
    const clonedObj = Object.assign({}, object)
    const targetKey = clonedObj[key]
    delete clonedObj[key]
    clonedObj[newKey] = targetKey
    return clonedObj
  },

  getUserTags: async function({ state }) {
    try {
      var response = await api.getUserTagList()
      if (response && response.result) {
        return response.result
      }
    } catch (error) {
      console.log(error)
    }
  },
  loadTags: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingUserTags = true
      if (state.userTags.length > 0) {
        resolve()
        state.loadingUserTags = false
      } else {
        dispatch('getUserTags').then(
          tags => {
            state.userTags = []
            if (tags.length > 0) {
              state.userTags = tags
            }
            state.loadingUserTags = false
            resolve()
          },
          error => {
            console.error(error)
            state.loadingUserTags = false
            reject(error)
          }
        )
      }
    })
  },

  getUserStatus: async function({ state }) {
    try {
      var response = await api.getUserStatusList()
      if (response && response.result) {
        return response.result
      }
    } catch (error) {
      console.log(error)
    }
  },
  loadStatus: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingUserStatus = true
      if (state.userStatus.length > 0) {
        resolve()
        state.loadingUserStatus = false
      } else {
        dispatch('getUserStatus').then(
          status => {
            state.userStatus = []
            if (status.length > 0) {
              state.userStatus = status
            }
            state.loadingUserStatus = false
            resolve()
          },
          error => {
            console.error(error)
            state.loadingUserStatus = false
            reject(error)
          }
        )
      }
    })
  },
  getSetting: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getSetting({ pageid: state.selectedBot.pageid }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadSetting: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingSetting = true
      dispatch('getSetting').then(
        setting => {
          var contents = []
          setting.map(function(content, index) {
            contents[content.contenttype] = content
          })
          state.setting = contents
          state.loadingSetting = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingSetting = false
          reject(error)
        }
      )
    })
  },
  getCharges: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getAllShipingCharge({ pageid: state.selectedBot.pageid }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.shippinglist) {
          resolve(response.shippinglist)
        } else {
          reject()
        }
      })
    })
  },
  loadCharges: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingCharges = true
      dispatch('getCharges').then(
        charges => {
          state.ecommerce.charges = charges
          state.ecommerce.loadingCharges = false
          resolve()
        },
        error => {
          console.error(error)
          state.ecommerce.loadingCharges = false
          reject(error)
        }
      )
    })
  },
  updateLivechatUsers: function({ commit }, payload) {
    commit(stateConfig.SET_LIVECHAT_USERS, payload)
  },
  updateLivechatUser: function({ commit }, payload) {
    commit(stateConfig.SET_LIVECHAT_USER, payload)
  },
  updateKetshopToken: function({ commit }, payload) {
    commit(stateConfig.SET_KETSHOP_TOKEN, payload)
  },
  async forceLoadLastestUsers({ state, dispatch }) {
    var promises = []
    for (const key in state.livechat.userlist) {
      if (state.livechat.userlist.hasOwnProperty(key)) {
        state.livechat.userlist[key].offset = 0
        if (state.livechat.filter.filter_admin_read !== null) {
          state.livechat.userlist[key].limit = 60
          state.livechat.limitFatchUser = 60
        } else {
          state.livechat.userlist[key].limit = state.livechat.limitFatchUser
        }
        state.livechat.userlist[key].loading = false
        state.livechat.userlist[key].hasMore = true

        promises.push(
          dispatch('loadLivechatUsers', {
            type: key
          })
        )
      }
    }
    return await Promise.all(promises)
  },
  async loadLatestUsers({ state, dispatch }, payload) {
    if (state.livechat.userlist[payload.type]) {
      var user_config = state.livechat.userlist[payload.type]
      if (user_config.loading || !user_config.isAutoRefresh) {
        return false
      }

      state.livechat.userlist[payload.type].offset = 0
      state.livechat.userlist[payload.type].limit = state.livechat.limitFatchUser
      await dispatch('loadLivechatUsers', payload)
    }
  },

  loadMoreLivechatUsers({ state, dispatch, getters }, payload) {
    return new Promise((resolve, reject) => {
      if (state.livechat.userlist[payload.type]) {
        state.livechat.userlist[payload.type].loading = true
        dispatch('getLivechatUsers', payload).then(
          users => {
            if (getters.selectedBot.pageid === '361231620965547') {
              notificationNewChatMessage({
                users,
                timeInterval: getters.getLivechatDetail('maxFetchUserTime')
              })
            }

            state.livechat.userlist[payload.type].users = state.livechat.userlist[
              payload.type
            ].users.concat(users)

            let array = new Map()
            for (const tag of state.livechat.userlist[payload.type].users) {
              array.set(tag.userid || tag.group_id, tag)
            }
            let final = [...array.values()]
            state.livechat.userlist[payload.type].users = final
            if (users && users.length === 0) {
              state.livechat.userlist[payload.type].hasMore = false
              state.livechat.userlist[payload.type].loading = false
            }

            if (
              state.livechat.userlist[payload.type].users.length <
                state.livechat.userlist[payload.type].limit ||
              state.livechat.userlist[payload.type].users.length == 0
            ) {
              state.livechat.userlist[payload.type].hasMore = false
              setInterval(() => {
                state.livechat.userlist[payload.type].hasMore = true
              }, 5000)
            }
            state.livechat.userlist[payload.type].loading = false
            resolve()
          },
          error => {
            state.livechat.userlist[payload.type].loading = false
            reject(error)
          }
        )
      }
    })
  },
  loadLivechatUsers({ state, dispatch, getters }, payload) {
    return new Promise((resolve, reject) => {
      if (state.livechat.userlist[payload.type]) {
        state.livechat.userlist[payload.type].loading = true
        dispatch('getLivechatUsers', payload).then(
          users => {
            if (getters.selectedBot.pageid === '361231620965547') {
              notificationNewChatMessage({
                users,
                timeInterval: getters.getLivechatDetail('maxFetchUserTime')
              })
            }

            dispatch('updateLivechatUsers', { users: users, type: payload.type })
            // if user less than limit or equal to zero. Livechat will not be fatch new user after 5 sec
            if (
              state.livechat.userlist[payload.type].users.length <
                state.livechat.userlist[payload.type].limit ||
              state.livechat.userlist[payload.type].users.length == 0
            ) {
              state.livechat.userlist[payload.type].hasMore = false
              setInterval(() => {
                state.livechat.userlist[payload.type].hasMore = true
              }, 5000)
            }
            state.livechat.userlist[payload.type].loading = false
            resolve()
          },
          error => {
            state.livechat.userlist[payload.type].loading = false
            reject(error)
          }
        )
      }
    })
  },
  getLivechatUsers: function({ state, getters }, payload) {
    return new Promise((resolve, reject) => {
      if (!getters.getUnlockLivechat) {
        resolve([])
        return false
      }
      var bot = getters.botlist.find(el => {
        return el.pageid == state.livechat.pageid
      })
      let data = {
        params: {},
        body: {
          userid: state.livechat.userid,
          pageid: state.livechat.pageid,
          line_tab: state.livechat.app === 'line' ? state.livechat.line_tab : 'user',
          offset: state.livechat.userlist[payload.type].offset,
          limit: state.livechat.userlist[payload.type].limit,
          line_modular_botid: bot && bot.line_modular_botid ? bot.line_modular_botid : null,
          app: state.livechat.app
        }
      }
      if (getters.isLivechatSearching) {
        var filters = {
          ...cloneDeep(state.livechat.filter)
        }
        filters.tags =
          filters.tags.length > 0 && typeof filters.tags !== 'string' ? filters.tags.join(',') : ''
        filters = pickBy(state.livechat.filter, function(value, key) {
          return !(
            value === undefined ||
            value === '' ||
            value == null ||
            (typeof value === 'object' && value.length == 0)
          )
        })

        data.body = {
          ...data.body,
          ...filters,
          inbox: 'all'
        }
      } else {
        data.body.app = state.livechat.app
        data.body.inbox = payload.type
      }
      if (state.livechat.filter.search) {
        Object.assign(data.body, { search: state.livechat.filter.search })
      }
      if (state.livechat.filter.datefrom && state.livechat.filter.dateto) {
        Object.assign(data.body, {
          datefrom: state.livechat.filter.datefrom,
          dateto: state.livechat.filter.dateto
        })
      }
      api.getLiveChatUsers(data, function(error, response) {
        if (error) {
          reject(error)
        }
        if (response.data) {
          resolve(response.data)
        } else {
          resolve([])
        }
      })
    })
  },
  updateNewcomer: function({ state }, payload) {
    state.newcomer = payload
    Vue.localStorage.set('newcomer', state.newcomer)
  },
  async getVerifyMeta({ state }, payload) {
    const response = await payload.get(
      `${state.selectedBot.facebook_page_id}/invoice_access_bank_account?access_token=${state.selectedBot.page_access_token}`,
      {
        custom_url: 'https://graph.facebook.com/v16.0/'
      }
    )
    let data = []
    if (
      response.data &&
      response.data.length > 0 &&
      response.data[0].verified_accounts &&
      response.data[0].verified_accounts.length > 0
    ) {
      response.data[0].verified_accounts.map(item => {
        data.push({
          id: item.bank_id,
          typeAccount: { value: 'meta', label: 'Meta' },
          bankAccountNo: item.account_num_last4,
          bankName: item.bank_code,
          name: item.account_holder_name,
          keyword: [],
          status: 'verified'
        })
      })
    }
    if (
      response.data &&
      response.data.length > 0 &&
      response.data[0].pending_verification_accounts &&
      response.data[0].pending_verification_accounts.length > 0
    ) {
      response.data[0].pending_verification_accounts.map(item => {
        data.push({
          id: item.bank_id,
          typeAccount: { value: 'meta', label: 'Meta' },
          bankAccountNo: item.account_num_last4,
          bankName: item.bank_code,
          name: item.account_holder_name,
          keyword: [],
          status: 'pending'
        })
      })
    }
    state.metaVerifySlip = data
  },
  getPageProfile: function({ state }) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }
      api.getShopProfile(data, function(error, response) {
        if (error) {
          console.error(error)

          reject()
        }
        if (response.shopprofile) {
          resolve(response.shopprofile)
        } else {
          resolve(null)
        }
      })
    })
  },
  loadPageProfile: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingPageProfile = true
      dispatch('getPageProfile').then(
        profile => {
          state.pageProfile = profile
          state.loadingPageProfile = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingPageProfile = false
          reject(error)
        }
      )
    })
  },
  getPartnerProfile: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getPartnerProfile({ partner_code: state.partner_code }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data && response.data.length > 0) {
          resolve(response.data[0])
        } else {
          reject()
        }
      })
    })
  },
  loadPartnerProfile: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingPartnerProfile = true
      dispatch('getPartnerProfile').then(
        partnerProfile => {
          state.partnerProfile = partnerProfile
          state.loadingPartnerProfile = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingPartnerProfile = false
          reject(error)
        }
      )
    })
  },
  getAstonAdmins: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getAstonAdmins({}, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadAstonAdmins: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingPartnerProfile = true
      dispatch('getAstonAdmins').then(
        astonAdmins => {
          state.astonAdmins = astonAdmins
          state.loadingAstonAdmins = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingAstonAdmins = false
          reject(error)
        }
      )
    })
  },
  toggleBotStatus({ state, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      var bot = payload

      api.toggleBotStatus(bot, function(error, response) {
        if (error) {
          reject(error)
        }

        let newbotlist = state.botlist
        var botIndex = newbotlist.findIndex(oldbot => {
          return bot.pageid == oldbot.pageid
        })
        if (newbotlist) {
          newbotlist[botIndex].status = bot.status
          dispatch('selectBot', bot)
          dispatch('updateBotlist', newbotlist)
        }

        resolve()
      })
    })
  },
  getIntent: function({ state }, payload) {
    return new Promise((resolve, reject) => {
      api.getIntent(
        { pageid: payload && payload.pageid ? payload.pageid : state.selectedBot.pageid },
        function(error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            resolve(response.data)
          } else {
            reject()
          }
        }
      )
    })
  },
  loadIntent: function({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_INTENTS', { intents: undefined, loadingIntents: true })
      dispatch('getIntent', payload).then(
        intents => {
          commit('SET_INTENTS', { intents, loadingIntents: false })
          resolve()
        },
        error => {
          commit('SET_INTENTS', { intents: [], loadingIntents: false })
          reject(error)
        }
      )
    })
  },
  setReportInboxMessage: function({ commit }, payload) {
    commit(stateConfig.SET_REPORT_INBOXMESSAGE, payload)
  },
  setReportReplyToComment: function({ commit }, payload) {
    commit(stateConfig.SET_REPORT_REPLYTOCOMMENT, payload)
  },
  setReportReplyToInbox: function({ commit }, payload) {
    commit(stateConfig.SET_REPORT_REPLYTOINBOX, payload)
  },
  setReportHideComment: function({ commit }, payload) {
    commit(stateConfig.SET_REPORT_HIDETOCOMMENT, payload)
  },
  sendMessageToServer({ state, commit }, payload) {
    let data = {
      params: { pageid: state.selectedBot.pageid },
      body: {
        message: payload.text,
        context: state.test_bot.contextOut,
        app: state.test_bot.channel
      }
    }
    if (payload.clearText) payload.clearText()

    commit('ADD_MESSAGE_TEST', {
      questiondata: payload.text,
      questiontype: 'text'
    })
    if (payload.scrollbottom) payload.scrollbottom()
    return new Promise((resolve, reject) => {
      api.test_webchat(data, function(error, response) {
        if (response.data.data.length !== 0) {
          commit('SET_CONTEXT_OUT', response.data.data.context_out)
          try {
            var rand = Math.floor(Math.random() * response.data.data.answer_value.length)
            commit('ADD_MESSAGE_TEST', {
              messagedata:
                typeof response.data.data.answer_value[rand] === 'string'
                  ? response.data.data.answer_value[rand]
                  : JSON.stringify(response.data.data.answer_value[rand]),
              messagetype: 'json',
              answerby: 'test',
              quick_reply: response.data.data.quick_reply
            })
          } catch (error) {}
          Vue.nextTick(() => {
            if (payload.scrollbottom) payload.scrollbottom()
            resolve()
          })
        }
        if (error) {
          Vue.swal.fire({
            type: 'error',
            text: 'ไม่สามารถส่งข้อความได้'
          })
          reject(error)
        }
      })
    })
  },
  async getLivechatUser({ commit, dispatch }, payload) {
    commit('SET_LIVECHAT_USER_DETAIL', undefined)
    let user = await dispatch('getUser', payload)
    if (user) commit('SET_LIVECHAT_USER_DETAIL', user)
    return user
  },
  getUser({}, payload) {
    let apiname = ''
    if (payload.group_id) {
      apiname = 'getUserOnlyGroup'
    } else {
      apiname = 'getUserOnly'
    }
    return new Promise((resolve, reject) => {
      api[apiname](payload, function(error, response) {
        if (error) {
          reject(error)
        }
        var data = []
        if (apiname === 'getUserOnlyGroup') {
          data = response
        } else {
          data = response.data
        }
        if (data && data.length > 0) {
          resolve(data[0])
        } else {
          resolve(undefined)
        }
      })
    })
  },
  getFBGetstarted: function({ state, getters }) {
    return new Promise((resolve, reject) => {
      var data = {
        pageid: state.selectedBot.pageid,
        access_token: state.selectedBot.page_access_token,
        status: state.selectedBot.status,
        fields: 'persistent_menu,get_started,ice_breakers',
        premium: state.selectedBot.pagetype == 'enterprise' || getters.getPackage == 'premium'
      }

      api.getPersistentMenu(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }

        resolve(response)
      })
    })
  },
  loadFBGetstarted: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingGetstarted = true
      dispatch('getFBGetstarted').then(
        getstarted => {
          state.getstarted = getstarted
          state.loadingGetstarted = false
          resolve(getstarted)
        },
        error => {
          console.error(error)
          state.loadingGetstarted = false
          reject(error)
        }
      )
    })
  },
  setMemberGroup: function({ commit }, payload) {
    commit('SET_MEMBERGROUP', payload)
  },
  getShippingcostdistance: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getShippingcostdistance({ pageid: state.selectedBot.pageid }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response) {
          resolve(response)
        } else {
          reject()
        }
      })
    })
  },
  loadShippingcostdistance: function({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_SHIPPING_COST_DISTANCE', { distances: undefined, loadingdistances: true })
      dispatch('getShippingcostdistance').then(
        response => {
          commit('SET_SHIPPING_COST_DISTANCE', {
            gmapapikey: response.googleapikey,
            distances: response.shippingcostdistance,
            loadingdistances: false
          })
          resolve()
        },
        error => {
          commit('SET_SHIPPING_COST_DISTANCE', { distances: [], loadingdistances: false })
          reject(error)
        }
      )
    })
  },
  connectToZerva: async function({ state, dispatch }, { businessId }) {
    try {
      dispatch('loading')

      const { status, data } = await axios.post(
        `${config.serverUrl}page/${state.selectedBot.pageid}/connect-zerva`,
        {
          business_profile_id: businessId,
          token: state.zwizSsoToken
        },
        { validateStatus: () => true }
      )

      if (status !== 200 || !data.success) {
        let errorMessage = data.message

        if (errorMessage === 'business_profile_id_already_connected') {
          errorMessage = `zerva.error_code.${errorMessage}`
        } else {
          errorMessage = 'unknown_error'
        }

        throw new Error(errorMessage)
      }

      const {
        connect_zerva_business_profile_id,
        connect_zerva_shop_profile_setting_id,
        connect_zerva_shop_profile_setting_name
      } = data.result

      state.selectedBot = {
        ...state.selectedBot,
        connect_zerva_business_profile_id,
        connect_zerva_shop_profile_setting_id,
        connect_zerva_shop_profile_setting_name
      }

      Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
    } finally {
      dispatch('loading')
    }
  },
  disconnectZerva: async function({ state, dispatch }) {
    try {
      dispatch('loading')

      const { status, data } = await axios.delete(
        `${config.serverUrl}page/${state.selectedBot.pageid}/disconnect-zerva`
      )

      if (status !== 200 || !data.success) {
        throw new Error(data.message)
      }

      state.selectedBot = {
        ...state.selectedBot,
        connect_zerva_business_profile_id: null,
        connect_zerva_shop_profile_setting_id: null,
        connect_zerva_shop_profile_setting_name: null
      }
      state.zwizSsoToken = null

      Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
    } finally {
      dispatch('loading')
    }
  },
  syncFbCoversation: async function({ state }, payload) {
    try {
      if (payload && payload.isChecked) {
        const res = await axios.post(
          `${config.serverUrl}page/${state.selectedBot.pageid}/sync-facebook-conversation`,
          { userid: payload.id }
        )
        const item = {
          id: payload.id
        }
        setLocalstorage(`syncChat.${payload.id}`, JSON.stringify(item), 600)
        return res
      }
    } catch (error) {}
  },
  unreadChat: async function({ state }, payload) {
    try {
      const res = await axios.post(`${config.serverUrl}adminunreadchat`, payload)
      return res
      // dispatch('syncFbCoversation')
    } catch (error) {}
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js